import { render, staticRenderFns } from "./BorrowBook.vue?vue&type=template&id=3e04ee9f&scoped=true&"
import script from "./BorrowBook.vue?vue&type=script&lang=js&"
export * from "./BorrowBook.vue?vue&type=script&lang=js&"
import style0 from "./BorrowBook.vue?vue&type=style&index=0&id=3e04ee9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e04ee9f",
  null
  
)

export default component.exports